function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_1522",
  "data-name": "Grupo 1522",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ret\\xE2ngulo_1434",
  "data-name": "Ret\\xE2ngulo 1434",
  transform: "translate(12.879 8.926) rotate(40)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1.3
}, /*#__PURE__*/React.createElement("rect", {
  width: 17.531,
  height: 20.036,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.65,
  y: 0.65,
  width: 16.231,
  height: 18.736,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Ret\\xE2ngulo_1435",
  "data-name": "Ret\\xE2ngulo 1435",
  transform: "translate(20.57 0) rotate(40)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1.3
}, /*#__PURE__*/React.createElement("rect", {
  width: 17.531,
  height: 10.018,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.65,
  y: 0.65,
  width: 16.231,
  height: 8.718,
  fill: "none"
})));

function SvgBetslipMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_1523",
    "data-name": "Grupo 1523",
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 35.543,
    viewBox: "0 0 34 35.543",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBetslipMobile);
export default __webpack_public_path__ + "static/media/betslipMobile.883fe373.svg";
export { ForwardRef as ReactComponent };